import React from "react";
import styled, { css } from "styled-components";
import Title, { TitleType } from "Components/Text/Title";
import ContainerDefault from "Components/Containers/ContainerDefault";
import media from "Styles/media";
interface AboutSectionProps {
	title?: string;
	div?: boolean;
}
const Wrapper = styled.div`
	color: white;
`;

const Container = styled(ContainerDefault)``;

const Inner = styled.div<{ div: boolean }>`
	padding: 100px 0;
	${(props) =>
		props.div
			? css`
					${props.theme.div.top(props.theme.color.gray.light, 1)}
			  `
			: css`
					padding-top: 0;
			  `};

	position: relative;
	width: 100%;
	display: flex;

	@media ${media.tablet} {
		padding: 64px 0;
		flex-direction: column;
	}
`;
const Col = styled.div``;
const ColTitle = styled(Col)`
	width: 30%;
	@media ${media.tablet} {
		width: 100%;
	}
`;
const ColContents = styled(Col)<{ full: boolean }>`
	width: ${(props) => (props.full ? "100%" : "70%")};
	@media ${media.tablet} {
		margin-top: 32px;
		width: 100%;
	}
`;
const CustomeTitle = styled(Title)`
	text-transform: lowercase;
	padding: 0;
	position: relative;

	${(props) =>
		props.theme.div.bottom(
			"white",
			0.5,
			`50%`,
			css`
				bottom: -2px;
				@media ${media.tablet} {
					width: 24px;
				}
			`
		)};
`;
const AboutSection: React.FC<AboutSectionProps> = ({ children, title, div = true }) => {
	return (
		<Wrapper>
			<Container>
				<Inner div={div}>
					{title && (
						<ColTitle>
							<CustomeTitle value={title} type={TitleType.SM} />
						</ColTitle>
					)}
					<ColContents full={!title}>{children}</ColContents>
				</Inner>
			</Container>
		</Wrapper>
	);
};

export default AboutSection;
